var model = BD.Model.extend({
    stateCode: BD.attr('string'),
    name: BD.attr('string'),
    country: BD.belongsTo('Billy.Country')
})
model.reopenClass({
    qProperties: ['stateCode', 'name']
})
module.exports = model
